import { Result } from '../../../../common/models/Result';
import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';
import { LocationType } from '../../../enums/LocationType';
import { PairsFrameLensGroupType } from '../../../enums/PairsFrameLensGroupType';
import { SeparationType } from '../../../enums/SeparationType';
import { CustomerRecipe } from '../../../models/CustomerRecipe';
import { GroupOfItemsWithCustomerRecipe } from '../../../models/GroupOfItemsWithCustomerRecipe';
import { Order } from '../../../models/Order';
import { Recipe } from '../../../models/Recipe';
import { ShopifyOrder } from '../../../models/ShopifyOrder';
import { StateLog } from '../../../models/StateLog';
import { StatePrescriptionLog } from '../../../models/StatePrescriptionLog';

export class GetPosOrderByShopifyIdService extends HttpServiceBase {

  handle = (input: GetPosOrderByShopifyIdServiceInput): Promise<Result<GetPosOrderByShopifyIdServiceOutput> | null> => {
    const promise = this.http.get<Result<GetPosOrderByShopifyIdServiceOutput>>(
      `${this.baseUrlSislogApi}/point-of-sale/order/${input.shopifyOrderId}?apiKey=${this.getSislogApiKey()}&with-groups=${input.withGroups ? 'true' : 'false'}`);
    return promise;
  }
}

export class GetPosOrderByShopifyIdServiceInput {
  shopifyOrderId!: string;
  withGroups?: boolean;
}

export class GetPosOrderByShopifyIdServiceOutput {
  shopifyId?: number;
  order?: Order;
  shopifyOrder?: ShopifyOrder;
  shopifyOrderSeparationType?: SeparationType;
  stateLog?: StateLog;
  statePrescriptionLog?: StatePrescriptionLog;
  groupsWithCustomerRecipe?: GroupOfItemsWithCustomerRecipe[] | null;
  customerRecipes?: CustomerRecipe[];
  recipes?: Recipe[];
  pairsFrameLensGroupType?: PairsFrameLensGroupType | null;
  locationType?: LocationType | null;
}